import {
  Directive,
  Output,
  Input,
  EventEmitter,
  HostBinding,
  HostListener,
} from '@angular/core';

@Directive({
  selector: '[appDnd]',
})
export class DndDirective {
  @HostBinding('class.fileover') fileDrag: boolean;
  @Output() fileDropped = new EventEmitter<any>();
  // Dragover listener
  @HostListener('dragover', ['$event']) onDragStart(evt) {
    //console.log('dragover')
    evt.preventDefault();
    evt.stopPropagation();
    this.fileDrag = true;
  }

  // Dragleave listener
  @HostListener('drag', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileDrag = false;
  }

  // Drop listener
  @HostListener('drop', ['$event']) public ondrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileDrag = false;
    const files = evt.dataTransfer.files;
    if (files.length > 0) {
      this.fileDropped.emit(files);
    }
  }
}
